<template>
  <base-dialog
    :show="showDialog"
    :title="$t('accounts.addNewAccount.title')"
    :actionName="$t('common.action.create')"
    @action="createAccount()"
    :actionDisabled="isValid()"
    :max-width="$vuetify.display.mdAndUp ? '30%' : '100%'"
    :isLoading="loading"
    :showCancel="$t('common.action.cancel')"
    buttonColor="blue"
    @close="showDialog = false"
  >
    <template #content>
      <div class="d-flex align-center">
        <span class="app-field-label">{{ $t("accounts.addNewAccount.companyName") }}</span>
      </div>
      <v-text-field v-model="name" :rules="locationRules" />
      <div class="d-flex align-center">
        <span class="app-field-label">{{ $t("accounts.addNewAccount.country") }}</span>
      </div>
      <v-select
        v-model="country"
        :items="supportCountries"
        item-title="name"
        item-value="code"
        :rules="selectRules"
        :placeholder="$t('accounts.addNewAccount.country')"
        persistent-placeholder
      />
    </template>
  </base-dialog>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import BaseDialog from "@/shared/components/Common/BaseDialog.vue";
import { useValidation } from "@/shared/composables/validation";
import { supportCountries } from "@/shared/constants/supportCountries";
import { useAuthStore } from "@/auth/stores/auth";

const { name, selectRules, locationRules } = useValidation();
const country = ref();
const loading = ref(false);
const showDialog = ref(false);

// Methods
const resetForm = () => {
  name.value = "";
  country.value = null;
};

const open = async () => {
  resetForm();
  showDialog.value = true;
};

defineExpose({
  open,
});

const isValid = () => {
  return !(name.value && country.value);
};

const createAccount = async () => {
  loading.value = true;

  await useAuthStore().createAccount({
    country: country.value,
    name: name.value,
    business_type: "company",
  });
};
</script>
